import { Link } from "react-router-dom";
import Titel from "../Components/admin/Titel";
import { BaseURL } from "../config/axios";
import { FavoriteContext } from "../providers/FavoriteContextProvider";
import { useContext } from "react";
import { BreadcrumbItem, Breadcrumbs } from "@nextui-org/react";

export default function Favorite() {
    const { state, dispatch } = useContext(FavoriteContext)

    return (
        <>
            <><title>گالری شخصی</title></>
            <div className="w-full px-4 md:px-6">
                <div className="container mx-auto" dir="rtl">
                    <div className="my-6">
                        <Breadcrumbs separator='/' className="pr-6 mb-6" itemClasses={{ separator: "px-2" }}>
                            <BreadcrumbItem href="/">صفحه اصلی</BreadcrumbItem>
                            <BreadcrumbItem>گالری شخصی</BreadcrumbItem>
                        </Breadcrumbs>
                        <div className="w-full bg-gray-200 rounded p-2" id="page_bilder_galery">
                            <Titel title='مورد علاقه من' className='w-full text-xl p-3' />
                            <div className="flex items-center my-3">
                                <div className="px-2 text-base italic">{state.itemsCounter} مورد یافت شد</div>
                            </div>
                            <div className="inline-flex flex-wrap items-stretch w-full">
                                {state.items.map(p => {
                                    return (
                                        <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 p-1 pb-2">
                                            <div className="flex flex-col border rounded-lg bg-gray-100 border-gray-300 text-center h-full">
                                                <div className="py-2 grow">
                                                    <Link to={`/product/${p.id}`} className="centerOfParent overflow-hidden h-full w-full">
                                                        <img className="max-w-full max-h-48 w-full h-full object-contain"
                                                            placeholder='blur' blurDataURL='/images/placeholder-1.png'
                                                            width={100} height={100}
                                                            src={BaseURL + p.images[0]?.path}
                                                            alt={`${p.title} by ${p.artist.title}`} title={`${p.title} by ${p.artist.title}`} />
                                                    </Link>
                                                </div>
                                                <div className="p-2">
                                                    <div className="text-lg text-primary font-bold">
                                                        <Link className="line-clamp-1" to={`/product/${p.id}`} title={p.title}>{p.title}</Link>
                                                    </div>
                                                    <hr className="my-2 border-gray-400" />
                                                    <div><Link to={`/artists/${p.artist.id}`}>{p.artist.title}</Link></div>
                                                    <br />
                                                    <hr className="mt-2 mb-6 border-gray-400" />
                                                    <Link to={`/product/${p.id}`}
                                                        className="text-white bg-main focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center">انتخاب تابلو</Link>
                                                    <p className="p-2 mt-4">
                                                        <button onClick={() => dispatch({ type: "REMOVE_ITEM", payload: p.id })} className="py-2.5 px-5 me-2 mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
                                                            حذف از موردعلاقه‌ها
                                                        </button>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
